/**
 * One line about a city's culture, the same words in the city panel and the city screen.
 */

import type { Content } from '../../content/schema/index.js';
import { culturePerTurn, nextBorderThreshold } from '../core/culture/index.js';
import type { City, GameState } from '../core/state/types.js';

export function cultureLine(state: GameState, content: Content, city: City): string {
  const per = culturePerTurn(state, content, city);
  const next = nextBorderThreshold(content, city.culture);
  const head = `${city.culture}${per > 0 ? ` · +${per} a turn` : ''}`;
  if (next === null) return `${head} · border at its widest`;
  if (per <= 0) return `${head} · border grows at ${next} — build a temple or library`;
  const turns = Math.ceil((next - city.culture) / per);
  return `${head} · border grows in ${turns} turn${turns === 1 ? '' : 's'}`;
}
